/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".DetailsList-grouped-example{display:block}\n"}]);